import axios from 'axios'

export default {
  getOffice: (id) => axios.get(`/offices/${id}`),
  /* Feature Activation  */
  putActivateFeature: (officeId, featureData) => axios.put(`/offices/${officeId}/features`, featureData),
  putActivateDevoluiva: (officeId) => axios.put(`/devoluiva/activate/${officeId}`, {}),
  /* Dynamic Validations  */
  getOfficeFormConfigurations: (filters = {}, page = 1) => axios.get('/office_form_configurations', { params: { page: page, ...filters } }),
  putOfficeFormConfigurations: (id, officeFormData) => axios.put(`/office_form_configurations/${id}`, officeFormData),
  /* Custom Fields */
  getTagTypes: (filters = {}, page = 1) => axios.get(`/tag_types`, { params: { page: page, ...filters } }),
  postTagTypes: (customField) => axios.post('/tag_types', customField),
  putTagType: (id, customField) => axios.put(`/tag_types/${id}`, customField),
  deleteTagType: (id) => axios.delete(`/tag_types/${id}`),
  /* Benefits */
  putOffice: async (id, data) => axios.put(`/offices/${id}`, data),
  /* Mileage Categories */
  getMileageCategories: (filters = {}, pagination = false, page = 1) => axios.get(`/mileage_categories`, { params: { page: page, pagination: pagination, ...filters } }),
  postMileageCategory: (mileageCategory) => axios.post('/mileage_categories', mileageCategory),
  putMileageCategory: (id, mileageCategory) => axios.put(`/mileage_categories/${id}`, mileageCategory),
  deleteMileageCategory: (mileageCategoryId) => axios.put(`/mileage_categories/delete/${mileageCategoryId}`, {}),
  /* Diet Categories */
  getDietCategories: (filters = {}, pagination = false, page = 1) => axios.get('/diet_categories', { params: { page: page, pagination: pagination, ...filters } }),
  postDietCategory: (dietCategory) => axios.post('/diet_categories', dietCategory),
  putDietCategory: (id, dietCateogry) => axios.put(`/diet_categories/${id}`, dietCateogry),
  putDeleteDietCategory: (id) => axios.put(`/diet_categories/delete/${id}`, {}),
  getAlertsSettings: () => axios.get(`/transaction_warning_offices`),
  putAlertsSettings: (id, alertsSettings) => axios.put(`/transaction_warning_offices/${id}`, alertsSettings),
  /* Review Flows */
  getReviewStatusFlows: (filters = {}, page = 1) => axios.get('/transaction_review_flows', { params: { page: page, ...filters } }),
  postReviewStatusFlow: (reviewStatusFlow) => axios.post('/transaction_review_flows', reviewStatusFlow),
  getReviewStatusFlow: (id) => axios.get(`/transaction_review_flows/${id}`),
  putReviewStatusFlow: (id, reviewStatusFlowData) => axios.put(`/transaction_review_flows/${id}`, reviewStatusFlowData),
  deleteReviewStatusFlow: (id) => axios.delete(`/transaction_review_flows/${id}`),
  /* Payment Methods */
  getOfficePaymentMethods: (filters = {}, pagination = false, page = 1) => axios.get('/office_payment_methods', { params: { page: page, pagination: pagination, ...filters } }),
  postOfficePaymentMethod: (paymentMethod) => axios.post('/office_payment_methods', paymentMethod),
  putOfficePaymentMethod: (id, updatedPaymentMethod) => axios.put(`/office_payment_methods/${id}`, updatedPaymentMethod),
  deleteOfficePaymentMethod: (id) => axios.delete(`/office_payment_methods/${id}`),
  // Cards Schedule
  getOfficeCardsSchedule: (filters = {}, pagination = false, page = 1) => axios.get('/budget_schedules', { params: { page: page, pagination: pagination, ...filters } }),
  postOfficeCardSchedule: (cardSchedule) => axios.post('/budget_schedules', cardSchedule),
  putOfficeCardSchedule: (id, updatedCardSchedule) => axios.put(`/budget_schedules/${id}`, updatedCardSchedule),
  deleteOfficeCardSchedule: (id) => axios.delete(`/budget_schedules/${id}`)
}
